<script setup lang="ts">
import OtherSiteSelect from '~/components/ui/select/footerotherselect.vue';



</script>

<template>
  <footer>
    <div class="footer-wrap">
      <div class="container">
        <div class="footer-top">
          <a-row>
            <a-col :xl="12" :lg="12" :span="24">
              <div class="footer-logo">
                <img src="~/assets/img/pc/main/footer-logoo.svg" alt="logo" />
              </div>
            </a-col>
            <a-col :xl="12" :lg="12" :span="24">
              <div class="other-site">
                <OtherSiteSelect />
              </div>
            </a-col>
          </a-row>
        </div>
        <div class="footer-bottom">
          <ul class="pc">
            <li>
              <span class="address">44428 울산광역시 중구 종가로 362-11, 울산과학기술종합센터</span>
              <span class="vr"></span>
              <strong>TEL.</strong>
              <span>052)219-0852</span>
              <strong>FAX.</strong>
              <span>052)219-0859</span>

            </li>
            <li class="copyright">
              COPYRIGHT© 2024 ULSAN TECHNOPARK. ALL RIGHTS RESERVED.
            </li>
          </ul>

          <ul class="mo">
            <li>
              <span class="address">44428 울산광역시 중구 종가로 362-11,<br />울산과학기술종합센터</span>

            </li>
            <li>
              <strong>TEL.</strong>
              <span>052)219-0852</span>
            </li>
            <li>
              <strong>FAX.</strong>
              <span>052)219-0859</span>
            </li>
            <li class="copyright">
              COPYRIGHT© 2024 ULSAN TECHNOPARK.<br />ALL RIGHTS RESERVED.
            </li>
          </ul>

        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>

</style>